import { get as getUser } from 'js/lib/user';

import { IdTypes, createFeatureScope } from 'bundles/product-features';

const dailyGoalsFeatureScope = createFeatureScope({
  globalCourseFeatures: {
    enableDailyGoals: true, // value is unused
  },
});

export const useIsDailyGoalsFeatureEnabled = ({
  shouldSkipQuery = false,
}: {
  shouldSkipQuery?: boolean;
}): { enabled: boolean; loading: boolean } => {
  const { features, loading } = dailyGoalsFeatureScope.useProductFeatures({
    idType: IdTypes.User,
    id: String(getUser().id),
    skip: shouldSkipQuery,
  });
  return {
    // Before loading, the default value is `true` based on the generated types
    // coming from the product features configuration repo.
    // So we need to return `false` before loading is complete to avoid the case where we start out
    // by returning `true` and later return `false` when loading is complete.
    enabled: loading ? false : features.get('globalCourseFeatures', 'enableDailyGoals'),
    loading,
  };
};
